import en_US from '../../en_US';

const extend = {
  movies: 'Sura',
  tvseries: 'Supplications',
  cartoons: 'Children'
};

const en_AR = {...en_US, ...extend};

export default en_AR;



// WEBPACK FOOTER //
// ./src/locales/dics/ext/art/en_AR.js